import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
      dropTarget: null,
      dragImg: null,
    };
  },
  methods: {
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    },

    initTableEvents() {
      // Check if the library table component is mounted.
      const loaded = document.getElementById('libraryTable');
      if (!loaded) {
        return;
      }
      this.dragImg = document.createElement('img');
      this.dragImg.src = `${process.env.BASE_URL}drag.png`;
      document.getElementById('libraryTable').addEventListener('dragstart', this.handleDragStart, { passive: true });
      document.getElementById('libraryTable').addEventListener('dragenter', this.handleDragEnter, { passive: true });
      document.getElementById('libraryTable').addEventListener('dragend', this.handleDragEnd, { passive: true });
      document.getElementById('libraryTable').addEventListener('drop', this.handleDrop, { passive: true });
    },

    removeTableEvents() {
      document.removeEventListener('dragstart', this.handleDragStart);
      document.removeEventListener('dragEnd', this.handleDragEnd);
      document.removeEventListener('dragenter', this.handleDragEnter);
    },

    dropZoneInit() {
      // Listen to all of the drag events and bind an event listener to each for the fileform.
      ['dragover', 'dragleave', 'drop', 'ondragstart'].forEach((evt) => {
        /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
        this.$refs.dropzone.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      });

      // Add a class when the user drags (a) file(s) over dropzone
      this.$refs.dropzone.addEventListener('dragover', () => {
        if (!this.rowSelection.length) {
          this.$refs.dropzone.classList.add('onDragover');
        }
      });

      // Remove a class when user leaves dropzone
      this.$refs.dropzone.addEventListener('dragleave', () => {
        this.$refs.dropzone.classList.remove('onDragover');
      });

      // Add an event listener for drop to the form
      this.$refs.dropzone.addEventListener('drop', (e) => {
        if (this.allowedToDrop) {
          // Set loadingstate to true
          this.isLoading = true;
          // Remove a class when user drops (a) file(s)
          this.$refs.dropzone.classList.remove('onDragover');
          // Capture the files from the drop event and add them to our local files array.
          this.dragFiles = [];
          // Loop trough dragged files and push to dragFiles-array
          for (let i = 0, it = 0; i < e.dataTransfer.files.length; i += 1) {
            this.dragFiles.push(e.dataTransfer.files[i]);
            it += 1;
            // If all files have been pushed to the array, -> upload
            if (it === e.dataTransfer.files.length) {
              this.uploadFiles(true);
            }
          }
        } else {
          this.$refs.dropzone.classList.remove('onDragover');
          this.$q.notify({
            message: getString('module.library.warning.noUpload'),
            color: 'warning',
            type: 'warning',
            position: 'center',
          });
        }
      });
    },

    handleDragStart(evt) {
      evt.dataTransfer.setData('text/plain', 'anything');
      evt.dataTransfer.setDragImage(this.dragImg, 1, 1);
      this.dragging = true;
    },

    handleDragEnter(evt) {
      this.dragging && evt.target.click();
    },

    handleDrop() {
      if (this.dropTarget === null) return;
      const targetName = this.dropTarget === 0 ? 'parent folder' : this.folders[this.dropTarget - 1].name;
      const targetLocation = this.dropTarget === 0 ? this.parentId : this.folders[this.dropTarget - 1].folder_id;

      // Prevent moving files into root folder
      if (!targetLocation) {
        this.qNoifty('module.library.error.move.root', 'warning', 'top-right');
        return;
      }

      this.moveLibraryFiles(this.rowSelection, targetLocation)
        .then((files) => {
          setTimeout(() => {
            this.qNotify(`Moved ${files.length} files into ${targetName}.`, 'positive', 'top-right', false, { timeout: 1000 });
            this.$refs.vuetable && this.$refs.vuetable.refresh();
          }, 300);
        })
        .finally(() => {
          // Remove draggable attribute and empty row selection.
          this.clearRowSelection();
        });
    },

    handleDragEnd() {
      this.dragging = false;
      this.isLoading = false;
    },

    moveLibraryFiles(files, target) {
      let path = this.activeDir.location.replace('api/', '').replace('library/', '');
      path = path[path.length - 1] !== '/' ? `${path}/` : path;

      let params = [
        `target=${target}`,
        `path=${path}`,
      ];
      const folderCount = this.folders.length + 1;

      files.forEach((file) => {
        const fileName = this.files[file - folderCount].location.split('/').slice(-1).pop();
        params.push(`filename[]=${fileName}`);
      });

      params = params.join('&');

      return new Promise((resolve) => {
        this.axios.put('library/move/?', params);
        window.setTimeout(() => {
          const rows = document.getElementsByClassName('ctrl-row-select');
          [].forEach.call(rows, (elem) => {
            elem.style.opacity = '0.2';
          });
          this.rowSelection = [];
          resolve(files);
        }, 350);
      });
    },

  },
};
